import React, { useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PreviewModal from './PreviewModal';
import { TemplateType, TemplateConfig } from './types';
import { PreviewLink } from './TemplatePreview';
import styles from './styles/templateConfigurator.module.css';

interface RowPreviewButtonProps {
  pageUrl: string;
  pageTitle: string;
  moduleId?: string;
  template: TemplateType;
  config: TemplateConfig;
  links: PreviewLink[];
  visible?: boolean;
}

export const RowPreviewButton: React.FC<RowPreviewButtonProps> = ({
  pageUrl,
  pageTitle,
  moduleId,
  template,
  config,
  links,
  visible = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  return (
    <>
      <Tooltip title="Preview template on this page">
        <IconButton
          size="small"
          onClick={handleClick}
          className={`${styles.rowPreviewButton} ${visible ? styles.visible : ''}`}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <PreviewModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        pageUrl={pageUrl}
        pageTitle={pageTitle}
        moduleId={moduleId}
        template={template}
        config={config}
        links={links}
      />
    </>
  );
};

export default RowPreviewButton;
